import { IconProps } from "../../../types/style";

const CarCancle = (prop: IconProps) => {
  const { color = "#ffffff", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.0002 2V12C15.0002 13.1 14.1002 14 13.0002 14H2.00024V7.62C2.73024 8.49 3.85027 9.03 5.09027 9C6.10027 8.98 7.01025 8.59 7.69025 7.94C8.00025 7.68 8.26027 7.34999 8.46027 6.98999C8.82027 6.37999 9.02024 5.65997 9.00024 4.90997C8.97024 3.73997 8.45026 2.71 7.64026 2H15.0002Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.0002 14V17C22.0002 18.66 20.6602 20 19.0002 20H18.0002C18.0002 18.9 17.1002 18 16.0002 18C14.9002 18 14.0002 18.9 14.0002 20H10.0002C10.0002 18.9 9.10024 18 8.00024 18C6.90024 18 6.00024 18.9 6.00024 20H5.00024C3.34024 20 2.00024 18.66 2.00024 17V14H13.0002C14.1002 14 15.0002 13.1 15.0002 12V5H16.8403C17.5603 5 18.2203 5.39001 18.5803 6.01001L20.2902 9H19.0002C18.4502 9 18.0002 9.45 18.0002 10V13C18.0002 13.55 18.4502 14 19.0002 14H22.0002Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8 22C9.10457 22 10 21.1046 10 20C10 18.8954 9.10457 18 8 18C6.89543 18 6 18.8954 6 20C6 21.1046 6.89543 22 8 22Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.0002 22C17.1048 22 18.0002 21.1046 18.0002 20C18.0002 18.8954 17.1048 18 16.0002 18C14.8957 18 14.0002 18.8954 14.0002 20C14.0002 21.1046 14.8957 22 16.0002 22Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22 12V14H19C18.45 14 18 13.55 18 13V10C18 9.45 18.45 9 19 9H20.29L22 12Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.00098 4.99988C9.00098 5.74988 8.79096 6.45988 8.42096 7.05988C8.21096 7.41988 7.94098 7.73988 7.63098 7.99988C6.93098 8.62988 6.01098 8.99988 5.00098 8.99988C3.54098 8.99988 2.27099 8.21988 1.58099 7.05988C1.21099 6.45988 1.00098 5.74988 1.00098 4.99988C1.00098 3.73988 1.58098 2.60988 2.50098 1.87988C3.19098 1.32988 4.06098 0.999878 5.00098 0.999878C7.21098 0.999878 9.00098 2.78988 9.00098 4.99988Z"
          stroke={color}
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.07117 6.04004L3.96118 3.93005"
          stroke={color}
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.04114 3.95984L3.93115 6.06982"
          stroke={color}
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export default CarCancle;
